import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-meal-plan-input',
  templateUrl: './meal-plan-input.component.html',
  styleUrls: ['./meal-plan-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MealPlanInputComponent),
      multi: true,
    },
  ],
})
export class MealPlanInputComponent implements ControlValueAccessor {
  @Input() items: any[] = []; // Array of items with { name, key }
  @Input() selectAllKey: any; // Key for the special checkbox
  selectedKeys: Set<string> = new Set<string>(); // Track selected keys
  isDisabled = false; // Control disabled state for non-selectAllKey items

  @Input() flexColumn: boolean = false;

  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  toggleSelection(key: string): void {
    if (key === this.selectAllKey) {
      if (this.selectedKeys.has(key)) {
        // Uncheck selectAllKey and enable others
        this.selectedKeys.delete(key);
        this.isDisabled = false;
      } else {
        // Check selectAllKey, unselect and disable others
        this.selectedKeys.clear();
        this.selectedKeys.add(key);
        this.isDisabled = true;
      }
    } else {
      // Toggle regular items
      if (this.selectedKeys.has(key)) {
        this.selectedKeys.delete(key);
      } else {
        this.selectedKeys.add(key);
      }
    }
    this.updateValue();
  }

  isSelected(key: string): boolean {
    return this.selectedKeys.has(key);
  }

  isCheckboxDisabled(key: string): boolean {
    return this.isDisabled && key !== this.selectAllKey;
  }

  private updateValue(): void {
    this.onChange(Array.from(this.selectedKeys));
  }

  // ControlValueAccessor methods
  writeValue(value: string[]): void {
    this.selectedKeys = new Set(value || []);
    this.isDisabled = this.selectedKeys.has(this.selectAllKey);
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // this.isDisabled = isDisabled;
  }
}
